export enum ApplicationErrorCode {
  NOT_CONFIRMED = 'NotConfirmed',
  OK = 'Ok'
}
